import {
    ControlBar,
    GridLayout,
    LiveKitRoom,
    ParticipantTile,
    RoomAudioRenderer,
    useTracks,
} from '@livekit/components-react';
import '@livekit/components-styles';
import {Track} from 'livekit-client';
import {useParams} from 'react-router-dom';
 


export default function Conference() {
    const {id:token} = useParams();
    
    if (!token) return <div>Loading...</div>;

    return (
        <LiveKitRoom
            video={true}
            audio={true}
            token={token}
            serverUrl={'wss://poketeste-5dfddstc.livekit.cloud'}
            // Use the default LiveKit theme for nice styles.
            data-lk-theme="default"
            draggable={true}
            style={{height: '100vh'}}>
            {/* Your custom component with basic video conferencing functionality. */}
            <MyVideoConference />
            {/* The RoomAudioRenderer takes care of room-wide audio for you. */}
            <RoomAudioRenderer />
            {/* Controls for the user to start/stop audio, video, and screen
        share tracks and to leave the room. */}
            <ControlBar controls={{microphone: true, camera: true, screenShare: false, leave: false}} />
        </LiveKitRoom>
    );
}

function MyVideoConference() {
    // `useTracks` returns all camera and screen share tracks. If a user
    // joins without a published camera track, a placeholder track is returned.
    const tracks = useTracks(
        [
            {source: Track.Source.Camera, withPlaceholder: true},
            {source: Track.Source.ScreenShare, withPlaceholder: false},
        ],
        {onlySubscribed: false},
    );
    return (
        <GridLayout tracks={tracks.reverse()} style={{height: 'calc(100vh - var(--lk-control-bar-height))'}}>
            {/* The GridLayout accepts zero or one child. The child is used
        as a template to render all passed in tracks. */}
            <ParticipantTile />
        </GridLayout>
    );
}
